// extracted by mini-css-extract-plugin
export default {"clockWrapper":"FooterClock_clockWrapper--m3P","clock":"FooterClock_clock--izU","icon":"FooterClock_icon--EuD"};